module.exports = __webpack_public_path__ + "img/394e5bf.png";